import { render, staticRenderFns } from "./CarRealTimeMonitor.vue?vue&type=template&id=2b353a72&scoped=true"
import script from "./CarRealTimeMonitor.vue?vue&type=script&lang=js"
export * from "./CarRealTimeMonitor.vue?vue&type=script&lang=js"
import style0 from "./CarRealTimeMonitor.vue?vue&type=style&index=0&id=2b353a72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b353a72",
  null
  
)

export default component.exports